import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks';

import { Row, TableView } from '~components/table-view-v3';

import accountCodesColumns from '~support-at-home/forms/settings/AccountCodesList';

import { deleteAccountCode, getAll, upsert } from '~support-at-home/actions/accountCodes';

import { selectAccountInvoiceCodes } from '~support-at-home/selectors/accountCodes';

interface ComponentProps {
  isActive: boolean;
}

const AccountCodes: React.FC<ComponentProps> = ({ isActive }) => {
  const dispatch = useAppDispatch();
  const accountCodes = useAppSelector(selectAccountInvoiceCodes);

  const [data, setData] = useState<Row[]>(accountCodes);

  const load = useCallback(async () => {
    await dispatch(getAll({ is_deleted: 'false' }));
  }, []);

  const handleChange = (rows: Row[]) => {
    setData(rows);
  };

  const handleSaveRow = async (row: Row) => {
    // Clean rows for upserting
    const { createdby_id, updatedby_id, created_at, updated_at, ...cleanRow } = row;

    const { payload } = await dispatch(upsert(cleanRow));
    if (payload?.success) {
      load();
    }
  };

  const handleDelete = async (rowId: string | number) => {
    if (!rowId) return;

    const existing = accountCodes.some(({ id }) => id === rowId);

    if (!existing) {
      setData((prev) => prev.filter((row) => row.id !== rowId));
      return;
    }

    const { payload } = await dispatch(deleteAccountCode({ id: rowId }));
    if (payload?.success) {
      load();
    }
  };

  useEffect(() => {
    setData(accountCodes);
  }, [accountCodes]);

  useEffect(() => {
    if (isActive) {
      load();
    }
  }, [isActive]);

  return (
    <div>
      <div className="p-2">
        <TableView
          id="accounts-codes-table"
          columns={accountCodesColumns}
          data={data}
          onChange={handleChange}
          onDeleteRow={handleDelete}
          emptyMessage={'No items found'}
          onSaveRow={handleSaveRow}
        />
      </div>
    </div>
  );
};

export default AccountCodes;
